import React from 'react';
function TeamShowcase() {
  const teamMembers = [{
    id: 1,
    name: "Sarah Johnson",
    role: "CEO & Founder",
    bio: "Visionary leader with 15+ years in tech innovation and business strategy.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBoZWFkc2hvdHxlbnwwfHx8fDE3NDkwNDAxMjV8MA&ixlib=rb-4.1.0&q=80&w=1080",
    attribution: {
      name: "Michael Dam",
      url: "https://unsplash.com/@michaeldam?utm_source=makerdevi&utm_medium=referral"
    }
  }, {
    id: 2,
    name: "Marcus Chen",
    role: "CTO",
    bio: "Full-stack architect passionate about creating scalable solutions and emerging technologies.",
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwyfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NDkwNDAxMjN8MA&ixlib=rb-4.1.0&q=80&w=1080",
    attribution: {
      name: "LinkedIn Sales Solutions",
      url: "https://unsplash.com/@linkedinsalesnavigator?utm_source=makerdevi&utm_medium=referral"
    }
  }, {
    id: 3,
    name: "Emily Rodriguez",
    role: "Design Director",
    bio: "Award-winning designer focused on creating intuitive and beautiful user experiences.",
    video: "https://res.cloudinary.com/makerinc/video/upload/v1770206748/devi-media/user_2ZAtAYc1MFcL5x3zo53g47MXUVS/cmciwvv1c009khs5rmi45dmla/fal-2cff66d3-6108-4fde-b717-d0bb5092b3e0.mp4"
  }, {
    id: 4,
    name: "David Park",
    role: "Lead Developer",
    bio: "Backend specialist with expertise in cloud architecture and performance optimization.",
    image: "https://images.unsplash.com/photo-1595211877493-41a4e5f236b3?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3MjgyNzB8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBwb3J0cmFpdHxlbnwwfHx8fDE3NDkwNDAxMjN8MA&ixlib=rb-4.1.0&q=80&w=1080",
    attribution: {
      name: "Ryan Hoffman",
      url: "https://unsplash.com/@ryanhoffman007?utm_source=makerdevi&utm_medium=referral"
    }
  }];
  return <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">Meet Our Team</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            A diverse group of passionate professionals dedicated to delivering excellence
          </p>
        </div>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map(member => <div key={member.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="relative">
                {member.video ? <video src={member.video} autoPlay loop muted playsInline className="w-full h-64 object-cover" /> : <>
                    <img src={member.image} alt={member.name} className="w-full h-64 object-cover" />
                    
                    {/* Image Attribution */}
                    {member.attribution && <span className="group/attribution absolute bottom-2 right-2 text-[10px] text-white outline outline-1 outline-white px-[6px] rounded-lg z-10 min-w-4 max-w-[calc(100%-16px)] h-4 leading-4 truncate text-center shadow">
                        <span className="block drop-shadow-md group-hover/attribution:hidden">i</span>
                        <span className="hidden drop-shadow-md group-hover/attribution:block">
                          Image on{' '}
                          <a href="https://unsplash.com?utm_source=Maker%20AI&utm_medium=referral" target="_blank" rel="noopener noreferrer" style={{
                    color: '#fff',
                    textDecoration: 'none'
                  }} data-tracking-id="link-b244dd1729607b84">
                            Unsplash
                          </a>{' '}
                          by{' '}
                          <a href={member.attribution.url} target="_blank" rel="noopener noreferrer" style={{
                    color: '#fff',
                    textDecoration: 'none'
                  }} data-tracking-id="link-2c1d2701ec6338ae">
                            {member.attribution.name}
                          </a>
                        </span>
                      </span>}
                  </>}
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-1">{member.name}</h3>
                <p className="text-green-600 font-medium mb-3">{member.role}</p>
                <p className="text-gray-600 text-sm">{member.bio}</p>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
export default TeamShowcase;